module.exports = __webpack_public_path__ + "static/media/cycling-temp-icon.a408b67a.svg";